// extracted by mini-css-extract-plugin
module.exports = {"cardImage":"CardImage_cardImage__2X_MM","noHover":"CardImage_noHover__JQJRu"};